import React, { useEffect, useState } from 'react';
import { CarehomeAddressType } from '@typings/CarehomeInfo';
import CarehomeAddress from '@components/team-member/organization-details/components/CarehomeAddress';

export interface GeneralPracticeType {
  gpName: string;
  gpPracticeName: string;
}

interface GeneralPracticeProps {
  generalPractice: GeneralPracticeType;
  setGeneralPractice: (value: GeneralPracticeType) => void;
  gpPracticeAddress: CarehomeAddressType;
  setGpPracticeAddress: React.Dispatch<
    React.SetStateAction<CarehomeAddressType>
  >;
  gpPracticeAddressFromData: CarehomeAddressType;
}

const GeneralPractice: React.FC<GeneralPracticeProps> = ({
  generalPractice,
  setGeneralPractice,
  gpPracticeAddress,
  setGpPracticeAddress,
  gpPracticeAddressFromData,
}) => {
  const [carehomeAddress, setCarehomeAddress] = useState<CarehomeAddressType>({
    addressLine1: '',
    addressLine2: '',
    city: '',
    county: '',
    postCode: '',
  });

  useEffect(() => {
    setGpPracticeAddress(carehomeAddress);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carehomeAddress]);

  useEffect(() => {
    if (gpPracticeAddressFromData) {
      setCarehomeAddress(gpPracticeAddressFromData);
    }
  }, [gpPracticeAddressFromData]);

  return (
    <div className="mt-10 govuk-bp:mt-14">
      <h1 className="govuk-heading-l">General Practice (GP)</h1>
      <div className="govuk-body">
        Details of the person&apos;s GP practice.
      </div>
      <div className="govuk-form-group">
        <h3 className="govuk-label-wrapper">
          <label className="govuk-label govuk-label--s" htmlFor="gpName">
            GP name
          </label>
        </h3>
        <div id="gp-name-hint" className="govuk-hint">
          The name of the person&apos;s GP. If the person is registered with a
          GP practice, their usual GP name will be something volunteered by the
          person or their representative.
        </div>
        <input
          className="govuk-input govuk-input--width-20"
          id="gpName"
          name="gpName"
          type="text"
          autoComplete="gpName"
          aria-describedby="gp-name-hint"
          value={generalPractice.gpName ?? ''}
          onChange={e =>
            setGeneralPractice({ ...generalPractice, gpName: e.target.value })
          }
        />
      </div>
      <div className="govuk-form-group">
        <h3 className="govuk-label-wrapper">
          <label
            className="govuk-label govuk-label--s"
            htmlFor="gpPracticeName"
          >
            GP Practice name
          </label>
        </h3>
        <div id="gp-practice-name-hint" className="govuk-hint">
          The name of the GP practice (not the person&apos;s GP)
        </div>
        <input
          className="govuk-input govuk-input--width-20"
          id="gpPracticeName"
          name="gpPracticeName"
          type="text"
          autoComplete="gpgpPracticeNameName"
          aria-describedby="gp-practice-name-hint"
          value={generalPractice.gpPracticeName ?? ''}
          onChange={e =>
            setGeneralPractice({
              ...generalPractice,
              gpPracticeName: e.target.value,
            })
          }
        />
      </div>

      <fieldset className="govuk-fieldset mt-10 govuk-bp:mt-14">
        <legend className="govuk-fieldset__legend govuk-fieldset__legend--s">
          <h3 className="govuk-fieldset__heading">GP Practice address</h3>
        </legend>
        <div id="gp-address-hint" className="govuk-hint">
          The address of the person&apos;s registered GP Practice. Registered GP
          practice details are available from the Person Demographics Service
          (PDS), or volunteered from the person or their representative.
        </div>

        <CarehomeAddress
          carehomeAddress={carehomeAddress}
          setCarehomeAddress={setCarehomeAddress}
        />
      </fieldset>
    </div>
  );
};

export default GeneralPractice;
